<div class="overlay" *ngIf="modal_type() === 'list_gateways'" (click)="handleCancel()">
  <div class="gateway-list-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="gateway-list-modal__header">
      <h2 class="gateway-list-modal__title">Gateway List</h2>
      <button class="gateway-list-modal__close" (click)="handleCancel()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="gateway-list-modal__content">
      <div class="gateway-list-modal__gateways">
        <div class="gateway-card" *ngFor="let gateway of gateways$ | async">
          <div class="gateway-card__info">
            <div class="gateway-card__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 3.5C9 2.67157 9.67157 2 10.5 2H13.5C14.3284 2 15 2.67157 15 3.5V4.5C15 5.32843 14.3284 6 13.5 6H10.5C9.67157 6 9 5.32843 9 4.5V3.5Z"
                  fill="currentColor" />
                <path
                  d="M4 9C4 7.89543 4.89543 7 6 7H18C19.1046 7 20 7.89543 20 9V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V9Z"
                  fill="currentColor" fill-opacity="0.3" />
                <circle cx="8" cy="11" r="1" fill="currentColor" />
                <circle cx="12" cy="11" r="1" fill="currentColor" />
                <circle cx="16" cy="11" r="1" fill="currentColor" />
              </svg>
            </div>
            <div class="gateway-card__details">
              <h3 class="gateway-card__name">{{ gateway.name || 'Unnamed Gateway' }}</h3>
              <p class="gateway-card__mac">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                {{ gateway.mac_address || 'No MAC Address' }}
              </p>
            </div>
          </div>

          <div class="gateway-card__actions">
            <button class="gateway-card__btn gateway-card__btn--edit" (click)="onEditGateway(gateway)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M12.5 2.5L15.5 5.5M2 16L2.5 13L13 2.5L15.5 5L5 15.5L2 16Z" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Edit
            </button>
            <button class="gateway-card__btn gateway-card__btn--delete" (click)="onDeleteGateway(gateway)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M3 4.5H15M6 4.5V3C6 2.44772 6.44772 2 7 2H11C11.5523 2 12 2.44772 12 3V4.5M7.5 8.25V12.75M10.5 8.25V12.75M4.5 4.5H13.5V15C13.5 15.5523 13.0523 16 12.5 16H5.5C4.94772 16 4.5 15.5523 4.5 15V4.5Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Delete
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="gateway-list-modal__empty" *ngIf="(gateways$ | async)?.length === 0">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="currentColor" fill-opacity="0.1" />
            <path
              d="M24 20C24 18.8954 24.8954 18 26 18H38C39.1046 18 40 18.8954 40 20V22C40 23.1046 39.1046 24 38 24H26C24.8954 24 24 23.1046 24 22V20Z"
              fill="currentColor" fill-opacity="0.5" />
            <path
              d="M18 28C18 26.8954 18.8954 26 20 26H44C45.1046 26 46 26.8954 46 28V44C46 45.1046 45.1046 46 44 46H20C18.8954 46 18 45.1046 18 44V28Z"
              fill="currentColor" fill-opacity="0.3" />
          </svg>
          <p>No gateways found</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Sensors List Modal -->
<div class="overlay" *ngIf="modal_type() === 'list_sensors'" (click)="handleCancel()">
  <div class="sensor-list-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="sensor-list-modal__header">
      <h2 class="sensor-list-modal__title">Sensor List</h2>
      <button class="sensor-list-modal__close" (click)="handleCancel()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="sensor-list-modal__content">
      <div class="sensor-list-modal__sensors">

        <div class="sensor-type-separator">
          <span class="sensor-type-separator__line"></span>
          <span class="sensor-type-separator__label">Piezo Sensors</span>
          <span class="sensor-type-separator__line"></span>
        </div>

        <!----------------------------------------------------------------------------------------------------->
        <!------------------------------------------------ PIEZO SENSORS -------------------------------------->
        <!----------------------------------------------------------------------------------------------------->
        <div class="sensor-card" *ngFor="let sensor of piezo_sensors">
          <!-- Sensor Header -->
          <div class="sensor-card__header">
            <div class="sensor-card__icon-wrapper">
              <div class="sensor-card__icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <circle cx="14" cy="14" r="10" stroke="currentColor" stroke-width="2" fill="none" />
                  <circle cx="14" cy="14" r="3" fill="currentColor" />
                  <path d="M14 4V8M14 20V24M4 14H8M20 14H24" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                </svg>
              </div>
              <span class="sensor-card__badge" [class.sensor-card__badge--new]="sensor.is_new">
                {{ sensor.is_new ? 'New' : 'Active' }}
              </span>
            </div>
            <div class="sensor-card__title-section">
              <h3 class="sensor-card__name">{{ sensor.sensorDNames || 'Unnamed Sensor' }}</h3>
              <p class="sensor-card__subtitle">
                {{ sensor.assetType }} - {{ sensor.subType?.replace('_', ' ') }}
              </p>

            </div>
          </div>

          <!-- Sensor Details Grid -->
          <div class="sensor-card__details">
            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"
                    fill="none" />
                  <path d="M6 6H10M6 10H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">MAC Address</span>
                <span class="sensor-detail__value">{{ sensor.mac_address || sensor.serial_number
                  }}</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 2V14M5 5L8 2L11 5M11 11L8 14L5 11" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">No. of Axis</span>
                <span class="sensor-detail__value">{{ sensor.no_of_axis }} Axis</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" fill="none" />
                  <path d="M8 5V8L10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Sensor Marker</span>
                <span class="sensor-detail__value">{{ sensor.sensorMarker }}</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 2C8 2 4 4 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 4 8 2 8 2Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  <path d="M8 12V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Temperature</span>
                <span class="sensor-detail__value">
                  {{ sensor.is_temperature_added ? 'Channel ' + sensor.temperature_channel : 'Not Added' }}
                </span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="3" y="4" width="10" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none" />
                  <path d="M6 4V3C6 2.44772 6.44772 2 7 2H9C9.55228 2 10 2.44772 10 3V4" stroke="currentColor"
                    stroke-width="1.5" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Asset Marker</span>
                <span class="sensor-detail__value">{{ sensor.assetMarker }}</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="5" cy="8" r="1.5" fill="currentColor" />
                  <circle cx="8" cy="8" r="1.5" fill="currentColor" />
                  <circle cx="11" cy="8" r="1.5" fill="currentColor" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Gateway ID</span>
                <span class="sensor-detail__value">#{{ sensor.gateway_id }}</span>
              </div>
            </div>
          </div>

          <!-- Axis Information -->
          <div class="sensor-card__axis" *ngIf="sensor.sensors_info">
            <div class="sensor-card__axis-header">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <span>Axis Configuration</span>
            </div>
            <div class="sensor-card__axis-list">
              <div class="axis-chip" *ngFor="let key of getAxisKeys(sensor.sensors_info)">
                <span class="axis-chip__label">{{ getAxisLabel(key) }}</span>
                <span class="axis-chip__value">{{ sensor.sensors_info[key] }}</span>
              </div>
            </div>
          </div>

          <!-- Status Indicators -->
          <div class="sensor-card__status">
            <div class="status-indicator" [class.status-indicator--active]="sensor.associated">
              <span class="status-indicator__dot"></span>
              <span>{{ sensor.associated ? 'Associated' : 'Not Associated' }}</span>
            </div>
            <div class="status-indicator" [class.status-indicator--active]="sensor.configured">
              <span class="status-indicator__dot"></span>
              <span>{{ sensor.configured ? 'Configured' : 'Not Configured' }}</span>
            </div>
            <div class="status-indicator" [class.status-indicator--active]="sensor.form_configured">
              <span class="status-indicator__dot"></span>
              <span>{{ sensor.form_configured ? 'Form Complete' : 'Form Incomplete' }}</span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="sensor-card__actions">
            <button class="sensor-card__btn sensor-card__btn--edit" (click)="onEditSensor(sensor)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M12.5 2.5L15.5 5.5M2 16L2.5 13L13 2.5L15.5 5L5 15.5L2 16Z" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Edit Sensor
            </button>
            <button class="sensor-card__btn sensor-card__btn--delete" (click)="onDeleteSensor(sensor)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M3 4.5H15M6 4.5V3C6 2.44772 6.44772 2 7 2H11C11.5523 2 12 2.44772 12 3V4.5M7.5 8.25V12.75M10.5 8.25V12.75M4.5 4.5H13.5V15C13.5 15.5523 13.0523 16 12.5 16H5.5C4.94772 16 4.5 15.5523 4.5 15V4.5Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Delete
            </button>
          </div>
        </div>

        <!-- PIEZO → EMSAVER SEPARATOR -->
        <div class="sensor-type-separator">
          <span class="sensor-type-separator__line"></span>
          <span class="sensor-type-separator__label">EMSaver Sensors</span>
          <span class="sensor-type-separator__line"></span>
        </div>

        <!----------------------------------------------------------------------------------------------------->
        <!------------------------------------------------ EMSAVER SENSORS ------------------------------------->
        <!----------------------------------------------------------------------------------------------------->
        <div class="sensor-card" *ngFor="let sensor of emsaver_sensors">
          <!-- Sensor Header -->
          <div class="sensor-card__header">
            <div class="sensor-card__icon-wrapper">
              <div class="sensor-card__icon">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <circle cx="14" cy="14" r="10" stroke="currentColor" stroke-width="2" fill="none" />
                  <circle cx="14" cy="14" r="3" fill="currentColor" />
                  <path d="M14 4V8M14 20V24M4 14H8M20 14H24" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" />
                </svg>
              </div>
              <span class="sensor-card__badge" [class.sensor-card__badge--new]="sensor.is_new">
                {{ sensor.is_new ? 'New' : 'Active' }}
              </span>
            </div>
            <div class="sensor-card__title-section">
              <h3 class="sensor-card__name">{{ sensor.sensorDNames || 'Unnamed Sensor' }}</h3>
              <p class="sensor-card__subtitle">
                {{ sensor.assetType }} - {{ sensor.subType?.replace('_', ' ') }}
              </p>

            </div>
          </div>

          <!-- Sensor Details Grid -->
          <div class="sensor-card__details">
            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.5"
                    fill="none" />
                  <path d="M6 6H10M6 10H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">MAC Address</span>
                <span class="sensor-detail__value">{{ sensor.mac_address || sensor.serial_number
                  }}</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5" fill="none" />
                  <path d="M8 5V8L10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Sensor Marker</span>
                <span class="sensor-detail__value">{{ sensor.sensorMarker }}</span>
              </div>
            </div>

            <div class="sensor-detail">
              <div class="sensor-detail__icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="3" y="4" width="10" height="8" rx="1" stroke="currentColor" stroke-width="1.5" fill="none" />
                  <path d="M6 4V3C6 2.44772 6.44772 2 7 2H9C9.55228 2 10 2.44772 10 3V4" stroke="currentColor"
                    stroke-width="1.5" />
                </svg>
              </div>
              <div class="sensor-detail__content">
                <span class="sensor-detail__label">Asset Marker</span>
                <span class="sensor-detail__value">{{ sensor.assetMarker }}</span>
              </div>
            </div>

          </div>

          <!-- Status Indicators -->
          <div class="sensor-card__status">
            <div class="status-indicator" [class.status-indicator--active]="sensor.form_configured">
              <span class="status-indicator__dot"></span>
              <span>{{ sensor.form_configured ? 'Form Complete' : 'Form Incomplete' }}</span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="sensor-card__actions">
            <button class="sensor-card__btn sensor-card__btn--edit" (click)="onEditSensor(sensor)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M12.5 2.5L15.5 5.5M2 16L2.5 13L13 2.5L15.5 5L5 15.5L2 16Z" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Edit Sensor
            </button>
            <button class="sensor-card__btn sensor-card__btn--delete" (click)="onDeleteSensor(sensor)">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M3 4.5H15M6 4.5V3C6 2.44772 6.44772 2 7 2H11C11.5523 2 12 2.44772 12 3V4.5M7.5 8.25V12.75M10.5 8.25V12.75M4.5 4.5H13.5V15C13.5 15.5523 13.0523 16 12.5 16H5.5C4.94772 16 4.5 15.5523 4.5 15V4.5Z"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Delete
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="sensor-list-modal__empty" *ngIf="piezo_sensors?.length === 0">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="currentColor" fill-opacity="0.1" />
            <circle cx="32" cy="32" r="16" stroke="currentColor" stroke-width="2" fill="none" opacity="0.5" />
            <circle cx="32" cy="32" r="4" fill="currentColor" opacity="0.5" />
            <path d="M32 8V16M32 48V56M8 32H16M48 32H56" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              opacity="0.5" />
          </svg>
          <p>No Piezo Sensors found</p>
        </div>
        <div class="sensor-list-modal__empty" *ngIf="emsaver_sensors?.length === 0">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="currentColor" fill-opacity="0.1" />
            <circle cx="32" cy="32" r="16" stroke="currentColor" stroke-width="2" fill="none" opacity="0.5" />
            <circle cx="32" cy="32" r="4" fill="currentColor" opacity="0.5" />
            <path d="M32 8V16M32 48V56M8 32H16M48 32H56" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              opacity="0.5" />
          </svg>
          <p>No Emsaver Sensors found</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Sensor Edit Modal -->
<div class="sensor-edit-overlay" (click)="handleCancel()" *ngIf="is_editing_sensor">
  <div class="sensor-edit-form" (click)="$event.stopPropagation()">
    <!-- Form Header -->
    <div class="sensor-edit-form__header">
      <div class="sensor-edit-form__header-content">
        <div class="sensor-edit-form__icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M12.5 2.5L15.5 5.5M2 16L2.5 13L13 2.5L15.5 5L5 15.5L2 16Z" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <h2 class="sensor-edit-form__title">Edit Sensor</h2>
          <p class="sensor-edit-form__subtitle">Update sensor configuration and axis mappings</p>
        </div>
      </div>
      <button class="sensor-edit-form__close" (click)="handleCancel()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Form Content -->
    <form [formGroup]="sensorForm" (ngSubmit)="handleSubmit()" class="sensor-edit-form__content">

      <!-- Basic Information Section -->
      <div class="form-section">
        <div class="form-section__header">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.5" fill="none" />
            <path d="M9 5V9L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <h3 class="form-section__title">Basic Information</h3>
        </div>

        <div class="form-grid">
          <!-- MAC Address -->
          <div class="form-field">
            <label class="form-field__label" for="mac_address">
              MAC Address <span class="form-field__required">*</span>
            </label>
            <input type="text" id="mac_address" formControlName="mac_address" class="form-field__input"
              [class.form-field__input--error]="hasError('mac_address')" placeholder="Enter MAC address" />
            <span class="form-field__error" *ngIf="hasError('mac_address', 'required')">
              MAC address is required
            </span>
          </div>

          <!-- Serial Number -->
          <div class="form-field">
            <label class="form-field__label" for="serial_number">
              Serial Number <span class="form-field__required">*</span>
            </label>
            <input type="text" id="serial_number" formControlName="serial_number" class="form-field__input"
              [class.form-field__input--error]="hasError('serial_number')" placeholder="Enter serial number" />
            <span class="form-field__error" *ngIf="hasError('serial_number', 'required')">
              Serial number is required
            </span>
          </div>

          <!-- Sensor Name -->
          <div class="form-field">
            <label class="form-field__label" for="sensorDNames">
              Sensor Name <span class="form-field__required">*</span>
            </label>
            <input type="text" id="sensorDNames" formControlName="sensorDNames" class="form-field__input"
              [class.form-field__input--error]="hasError('sensorDNames')" placeholder="e.g., BASE, DE, NDE" />
            <span class="form-field__error" *ngIf="hasError('sensorDNames', 'required')">
              Sensor name is required
            </span>
          </div>

          <!-- Sensor Marker -->
          <div class="form-field">
            <label class="form-field__label" for="sensorMarker">
              Sensor Marker <span class="form-field__required">*</span>
            </label>
            <input type="text" id="sensorMarker" formControlName="sensorMarker" class="form-field__input"
              [class.form-field__input--error]="hasError('sensorMarker')" placeholder="Enter sensor marker" />
            <span class="form-field__error" *ngIf="hasError('sensorMarker', 'required')">
              Sensor marker is required
            </span>
          </div>

          <!-- Asset Marker -->
          <div class="form-field">
            <label class="form-field__label" for="assetMarker">
              Asset Marker <span class="form-field__required">*</span>
            </label>
            <select id="assetMarker" formControlName="assetMarker" class="form-field__input"
              [class.form-field__input--error]="hasError('assetMarker')">
              <option value="">Select asset marker</option>
              <option value="MASTER">MASTER</option>
              <option value="CHILD">CHILD</option>
            </select>
            <span class="form-field__error" *ngIf="hasError('assetMarker', 'required')">
              Asset marker is required
            </span>
          </div>

          <!-- Gateway ID -->
          <div class="form-field">
            <label class="form-field__label" for="gateway_id">
              Gateway ID <span class="form-field__required">*</span>
            </label>
            <input type="number" id="gateway_id" formControlName="gateway_id" class="form-field__input"
              [class.form-field__input--error]="hasError('gateway_id')" placeholder="Enter gateway ID" />
            <span class="form-field__error" *ngIf="hasError('gateway_id', 'required')">
              Gateway ID is required
            </span>
          </div>

          <!-- Asset Type -->
          <div class="form-field">
            <label class="form-field__label" for="assetType">
              Asset Type <span class="form-field__required">*</span>
            </label>
            <input type="text" id="assetType" formControlName="assetType" class="form-field__input"
              [class.form-field__input--error]="hasError('assetType')" placeholder="e.g., MOTOR" />
            <span class="form-field__error" *ngIf="hasError('assetType', 'required')">
              Asset type is required
            </span>
          </div>

          <!-- Sub Type -->
          <div class="form-field">
            <label class="form-field__label" for="subType">
              Sub Type <span class="form-field__required">*</span>
            </label>
            <input type="text" id="subType" formControlName="subType" class="form-field__input"
              [class.form-field__input--error]="hasError('subType')" placeholder="e.g., INDUCTION_MOTOR" />
            <span class="form-field__error" *ngIf="hasError('subType', 'required')">
              Sub type is required
            </span>
          </div>
        </div>
      </div>

      <!-- Axis Configuration Section -->
      <div class="form-section">
        <div class="form-section__header">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9 1V17M1 9H17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <h3 class="form-section__title">Axis Configuration</h3>
        </div>

        <!-- Number of Axis -->
        <div class="form-field">
          <label class="form-field__label" for="no_of_axis">
            Number of Axis <span class="form-field__required">*</span>
          </label>
          <div class="axis-selector">
            <button type="button" class="axis-selector__btn"
              [class.axis-selector__btn--active]="sensorForm.get('no_of_axis')?.value === 1"
              (click)="sensorForm.patchValue({no_of_axis: 1})">
              1 Axis
            </button>
            <button type="button" class="axis-selector__btn"
              [class.axis-selector__btn--active]="sensorForm.get('no_of_axis')?.value === 2"
              (click)="sensorForm.patchValue({no_of_axis: 2})">
              2 Axis
            </button>
            <button type="button" class="axis-selector__btn"
              [class.axis-selector__btn--active]="sensorForm.get('no_of_axis')?.value === 3"
              (click)="sensorForm.patchValue({no_of_axis: 3})">
              3 Axis
            </button>
          </div>
        </div>

        <!-- Dynamic Axis Mappings -->
        <div class="axis-mappings" formArrayName="axis_mappings">
          <div class="axis-mapping-card" *ngFor="let mapping of axisMappings.controls; let i = index"
            [formGroupName]="i">
            <div class="axis-mapping-card__header">
              <div class="axis-mapping-card__badge">Sensor {{ i + 1 }}</div>
            </div>

            <div class="axis-mapping-card__content">
              <!-- Axis Selection -->
              <div class="form-field">
                <label class="form-field__label">
                  Axis <span class="form-field__required">*</span>
                </label>
                <select formControlName="axis" class="form-field__input"
                  [class.form-field__input--error]="hasAxisMappingError(i, 'axis')">
                  <option value="">Select axis</option>
                  <option *ngFor="let axis of availableAxes" [value]="axis" [disabled]="isAxisSelected(axis, i)">
                    {{ axis }}
                  </option>
                </select>
                <span class="form-field__error" *ngIf="hasAxisMappingError(i, 'axis')">
                  Axis is required
                </span>
              </div>

              <!-- Channel Input -->
              <div class="form-field">
                <label class="form-field__label">
                  Channel <span class="form-field__required">*</span>
                </label>
                <select formControlName="channel" class="form-field__input"
                  [class.form-field__input--error]="hasAxisMappingError(i, 'channel')">
                  <option value="">Select Channel</option>
                  <option *ngFor="let c of filtered_channels" [value]="c">
                    {{ c }}
                  </option>
                </select>
                <div
                  *ngIf="sensorForm.get('axis_mappings')?.errors?.duplicateAxis && sensorForm.get('axis_mappings')?.touched"
                  class="error-message">
                  ❌ Two or more axes are the same!
                </div>
                <div
                  *ngIf="sensorForm.get('axis_mappings')?.errors?.duplicateChannel && sensorForm.get('axis_mappings')?.touched"
                  class="error-message">
                  ❌ Two or more channels are the same!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Temperature Section -->
      <div class="form-section">
        <div class="form-section__header">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9 2C9 2 6 4 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 4 11 2 11 2"
              stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M10 12V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <h3 class="form-section__title">Temperature Configuration</h3>
        </div>

        <!-- Temperature Toggle -->
        <div class="form-field">
          <label class="toggle-field">
            <input type="checkbox" formControlName="is_temperature_added" [value]="1"
              [checked]="sensorForm.get('is_temperature_added')?.value === 1"
              (change)="sensorForm.patchValue({is_temperature_added: $event.target.checked ? 1 : 0})" />
            <span class="toggle-field__switch"></span>
            <span class="toggle-field__label">Enable Temperature Monitoring</span>
          </label>
        </div>

        <!-- Temperature Channel (Conditional) -->
        <div class="form-field mt-4" *ngIf="sensorForm.get('is_temperature_added')?.value === 1">
          <label class="form-field__label" for="temperature_channel">
            Temperature Channel <span class="form-field__required">*</span>
          </label>
          <select formControlName="temperature_channel" class="form-field__input">
            <option value="">Select Channel</option>
            <option *ngFor="let c of filtered_channels" [value]="c">
              {{ c }}
            </option>
          </select>
          <div
            *ngIf="sensorForm.get('temperature_channel')?.errors?.duplicateChannel && sensorForm.get('temperature_channel')?.touched"
            class="error-message">
            ❌ Two or more channels are the same!
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="button" class="form-actions__btn form-actions__btn--cancel" (click)="handleCancel()">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" />
          </svg>
          Cancel
        </button>
        <button type="submit" class="form-actions__btn form-actions__btn--save" [disabled]="sensorForm.invalid">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M15 5L7 13L3 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          Save Changes
        </button>
      </div>
    </form>
  </div>
</div>

<div class="overlay" *ngIf="editing_gateway" (click)="handleCancel()">
  <div class="gateway-edit-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="gateway-edit-modal__header">
      <h2 class="gateway-edit-modal__title">Edit Gateway</h2>
      <button class="gateway-edit-modal__close" (click)="handleCancel()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <form [formGroup]="gatewayForm" (ngSubmit)="saveGatewayConfig()" class="gateway-edit-modal__content">
      <!-- MAC ADDRESS (DISABLED) -->
      <div class="form-field">
        <label class="form-field__label" for="gateway_mac">
          MAC Address <span class="form-field__required">*</span>
        </label>
        <input type="text" id="gateway_mac" formControlName="mac" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('mac')" placeholder="Enter MAC address" disabled />
        <span class="form-field__error" *ngIf="hasGatewayError('mac', 'required')">
          MAC address is required
        </span>
      </div>

      <!-- SERIAL NUMBER (DISABLED) -->
      <div class="form-field">
        <label class="form-field__label" for="name">
          Serial Number
        </label>
        <input type="text" id="name" formControlName="name" class="form-field__input" disabled
          placeholder="Serial number unavailable" />
      </div>

      <!-- ASSET THRESHOLD STATUS -->
      <div class="form-field">
        <label class="form-field__label" for="asset_threshold_status">
          Asset Threshold Status
        </label>
        <input type="number" id="asset_threshold_status" formControlName="asset_threshold_status"
          class="form-field__input" [class.form-field__input--error]="hasGatewayError('asset_threshold_status')" />
        <span class="form-field__error" *ngIf="hasGatewayError('asset_threshold_status','min')">
          Value must be ≥ 0
        </span>
      </div>

      <!-- SCAN RATE -->
      <div class="form-field">
        <label class="form-field__label" for="scan_rate">
          Scan Rate (sec)
        </label>
        <input type="number" id="scan_rate" formControlName="scan_rate" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('scan_rate')" />
        <span class="form-field__error" *ngIf="hasGatewayError('scan_rate','min')">
          Minimum 1 second required.
        </span>
      </div>

      <!-- ANOMALY COUNTER -->
      <div class="form-field">
        <label class="form-field__label" for="anomaly_counter">
          Anomaly Counter (1–5)
        </label>
        <input type="number" id="anomaly_counter" formControlName="anomaly_counter" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('anomaly_counter')" />
        <span class="form-field__error" *ngIf="hasGatewayError('anomaly_counter','min')">
          Minimum value is 1.
        </span>
        <span class="form-field__error" *ngIf="hasGatewayError('anomaly_counter','max')">
          Maximum value is 5.
        </span>
      </div>

      <!-- ANOMALY ANALYSIS -->
      <div class="form-field">
        <label class="form-field__label" for="anomaly_analysis">
          Anomaly Analysis Rate (sec)
        </label>
        <input type="number" id="anomaly_analysis" formControlName="anomaly_analysis" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('anomaly_analysis')" />
      </div>

      <!-- FULL REFRESH RATE -->
      <div class="form-field">
        <label class="form-field__label" for="full_refresh_rate">
          Full Refresh Rate (sec)
        </label>
        <input type="number" id="full_refresh_rate" formControlName="full_refresh_rate" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('full_refresh_rate')" />
      </div>

      <!-- SUMMARY REFRESH RATE -->
      <div class="form-field">
        <label class="form-field__label" for="summary_refresh_rate">
          Summary Refresh Rate (sec)
        </label>
        <input type="number" id="summary_refresh_rate" formControlName="summary_refresh_rate" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('summary_refresh_rate')" />
      </div>

      <!-- ODR DROPDOWN -->
      <div class="form-field">
        <label class="form-field__label" for="odr">
          ODR (Output Data Rate)
        </label>
        <select id="odr" formControlName="odr" class="form-field__input"
          [class.form-field__input--error]="hasGatewayError('odr')">
          <option *ngFor="let option of odr_options" [value]="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>

      <!-- ACTION BUTTONS -->
      <div class="form-actions">
        <button type="button" class="form-actions__btn form-actions__btn--cancel" (click)="handleGatewayConfigCancel()">
          Cancel
        </button>
        <button type="submit" class="form-actions__btn form-actions__btn--save" [disabled]="gatewayForm.invalid">
          Save Changes
        </button>
      </div>

    </form>
  </div>
</div>

<div class="overlay" *ngIf="this.modal_type()=='delete_powertrain'" (click)="handleCancel()">
  <div class="gateway-edit-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="gateway-edit-modal__header">
      <h2 class="gateway-edit-modal__title">Delete Powertrain</h2>
      <button class="gateway-edit-modal__close" (click)="handleCancel()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <form (ngSubmit)="deletePiezoAsset()" class="gateway-edit-modal__content">
      <!-- MAC ADDRESS (DISABLED) -->
      <div class="form-field">
        Are you sure you want to delete this powertrain? This action cannot be undone.
      </div>

      <!-- ACTION BUTTONS -->
      <div class="form-actions">
        <button type="button" class="form-actions__btn form-actions__btn--cancel" (click)="handleGatewayConfigCancel()">
          Cancel
        </button>
        <button type="submit" class="form-actions__btn form-actions__btn--save">
          Delete
        </button>
      </div>

    </form>
  </div>
</div>